export const TEXT_BUTTON_UNDO = 'text-button-undo';
export const TEXT_BUTTON_REDO = 'text-button-redo';
